// extracted by mini-css-extract-plugin
export default {"dropbtn":"navbarSignUp_dropbtn__GakX1","dropdown":"navbarSignUp_dropdown__H0kUS","dropdownContent":"navbarSignUp_dropdownContent__Kg0d+"};